module.exports = __webpack_public_path__ + "img/navLogo.8ed0bf76.png";